export default function findValuesRecursive(object: {[key: string]: any }, key: string) {
    let values: any[] = []

    Object.keys(object).some(
        (currentKey) => {
            if (currentKey === key) {
                values.push(object[currentKey])
            }

            if (object[currentKey] && typeof object[currentKey] === 'object') {
                values = [...values, ...findValuesRecursive(object[currentKey], key)]
            }
        }
    )

    return values
}
